import { LogEntry, World } from '../types';

/** `2025-03-09 14:05:33` in the viewer's local time. */
export const fmtLogTs = (ts: number): string => {
  const d = new Date(ts);
  const pad = (n: number, w = 2) => String(n).padStart(w, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

/** `My_World-7f1acf6c`, the start of every file name the site offers for a world. */
export const worldFilePrefix = (world: World): string => `${world.name.replace(/[^\w.-]+/g, '_')}-${world.id.slice(0, 8)}`;

/** Offers the text as a download called `fileName`. */
export const saveText = (fileName: string, text: string): void => {
  const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

/** Offers the lines as a .txt download, oldest first. */
export const downloadLogs = (world: World, entries: LogEntry[], suffix = 'logs'): void => {
  const text = [...entries]
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((l) => `${fmtLogTs(l.timestamp)} ${l.message}`)
    .join('\n');
  saveText(`${worldFilePrefix(world)}-${suffix}.txt`, text);
};
